module.exports = __webpack_public_path__ + "img/AMP-alt.000d94b8.svg";